const crypto = require('crypto')
const path = require('path')
const fs = require('fs')


export class CryptoHelpers {

    static encrypt(toEncrypt, relativeOrAbsolutePathToPublicKey) {
        const absolutePath = path.resolve(relativeOrAbsolutePathToPublicKey)
        const publicKey = fs.readFileSync(absolutePath, 'utf8')
        const buffer = Buffer.from(toEncrypt, 'utf8')
        const encrypted = crypto.publicEncrypt(publicKey, buffer)
        return encrypted.toString('base64')
    }

    static decrypt(toDecrypt, relativeOrAbsolutePathtoPrivateKey) {
        const absolutePath = path.resolve(relativeOrAbsolutePathtoPrivateKey)
        const privateKey = fs.readFileSync(absolutePath, 'utf8')
        const buffer = Buffer.from(toDecrypt, 'base64')
        const decrypted = crypto.privateDecrypt(
            {
                key: privateKey.toString(),
                passphrase: '',
            },
            buffer,
        )
        return decrypted.toString('utf8')
    }

    static decryptForce(toDecrypt) {
        const absolutePath = path.resolve('./private.pem')
        const privateKey = fs.readFileSync(absolutePath, 'utf8')
        const buffer = Buffer.from(toDecrypt, 'base64')
        const decrypted = crypto.privateDecrypt(
            {
                key: privateKey.toString(),
                passphrase: '',
            },
            buffer,
        )
        return decrypted.toString('utf8')
    }
    // Decrypt with Private Key
    static decryptWithPrivateKeyForce(ciphertext: string): string {
        const absolutePath = path.resolve('./private.pem')
        const privateKey = fs.readFileSync(absolutePath, 'utf8');

        const decryptedBuffer = crypto.privateDecrypt(
            {
                key: privateKey,
                passphrase: 'Econ@ID',
                padding: crypto.constants.RSA_PKCS1_OAEP_PADDING,
                oaepHash: 'sha256',
            },
            Buffer.from(ciphertext, 'base64')
        );

        return decryptedBuffer.toString('utf8');
    }

}